import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { MatomoTracker } from 'ngx-matomo';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { delay } from 'rxjs';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-WmsmContractTemplateManagementComponent',
  templateUrl: './wmsm-ContractTemplateManagement.component.html',
  styleUrls: ['./wmsm-ContractTemplateManagement.component.scss'],
})

export class WmsmContractTemplateManagementComponent extends BaseComponent implements OnInit {
  pageSize: number = 20;
  // 表格页码
  //监听条件区数值改变，改变则往下传值
  @Output() listenForm = new EventEmitter();
  //实现查询时/点击时，条件区小三角形收缩
  @Input() isShowCondition: boolean = true;
  //user的权限控制
  @Input() show: boolean;
  //实现查询时/点击时，条件区小三角形收缩
  @Output() outQuery = new EventEmitter();
  public uploadedFileName: string;
  public fileToken: string;
  select: boolean = false
  role4: boolean = false
  role0: boolean = false

  SiteList: any;
  TypeList: any;
  pageIndex: number = 1;
  fileList: NzUploadFile[] = [];
  total: number = 0;
  validateForm: FormGroup;
  formValues: any;
  chartOption: any;
  seriesData: any[];
  SiteAll: any;
  option: any;
  startValue: any = 10;
  endValue: any = 100;
  dataZoomOrient: any = 'horizontal';
  barChartOrient: any = 'vertical';
  loading: boolean = false;
  isShowinfo: boolean = false;
  monthFormat = 'yyyy/MM/dd';
  showNoteflag: boolean;
  showchart: boolean;
  id_chart: string = 'link_Request';
  ComplianceIndexCondition: any;
  chartY: [];
  nzTitle: any;
  listofreportdata: any;
  NTBCost: any;
  tw: boolean;
  cn: boolean;
  en: boolean;
  id: any;
  myChart;
  role: any;
  siteadmin: any;
  filename: any
  selectedValue: string = "";
  cancelSelection = false;
  UploadProofFile: NzUploadFile = null;
  sitename: any;
  fixedColumn = true;

  isVisible = false;

  constructor(
    private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private matomotracker: MatomoTracker,
    private NzMessageService: NzMessageService,
    private http: HttpClient,
    private AuthService: AuthService,
    private tanslateService: TranslateService,
    private LayoutComponent: LayoutComponent,


  ) { super(); }

  ngOnInit(): void {
    this.matomotracker.trackPageView("合同管理")
    this.matomotracker.trackEvent("合同管理", "合同模板", "Transation", 1);
    this.GetSite();
    this.LayoutComponent.geturl();
    this.validateForm = this.fb.group({
      ContractName: [""],
      Versions: [''],
      ContractNameEn: [''],
      Type: [''],
      CNContractName: [''],
      ENContractName: [''],
      ModalVersions: [''],
      ModalSite: [''],
      ModalType: [''],
      FORMNumber: [''],
      Limit: [''],
      TypeCode: [''],
      Background: ["", [Validators.maxLength(350)]],
      Purpose: ["", [Validators.maxLength(350)]],
    });





    this.ContollerButton();
    this.GetLanguage();
    this.GetContractTypeCode()
  }



  ContollerButton() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    const params = {
    };

    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        const roles = res.data as string[];
        if (roles.includes("3")) {
          this.select = true
          this.role0 = true
        } else if (roles.includes("4")) {
          this.role4 = true
          this.role0 = true
          const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
          const params = {
          };
          this.webApiService.doPost(url, params).subscribe(
            (site) => {
              this.sitename = site['0'].siteName
            },
            (error) => {
            }
          );
        } else if (roles.includes("0")) {
          this.role0 = false
        }
      }
    );
  }


  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }
  }

  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.getReport()
    this.GetLanguage();
    this.isShowinfo = true;
  }

  showNote(note: string): void {
    if (note == 'isshowNote') {
      this.showNoteflag = true;
    }
  }

  CloseNote(note: string): void {
    this.showNoteflag = false;
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.total === 0) {
      return;
    }

    this.pageSize = event;
    if (event * this.pageIndex > this.total && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getReport();
  }

  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getReport();
  }


  getReport() {
    this.loading = true;
    const startDate = this.getStartOfDayString(this.formValues?.UploadTime?.[0]) || '';
    const endDate = this.getStartOfDayString(this.formValues?.UploadTime?.[1]) || '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetAdminContractList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        ChContractName: this.formValues.ContractName,
        EnContractName: this.formValues.ContractNameEn,
        Versions: this.formValues.Versions,
        Status: this.formValues.Status,
        Site: this.formValues.Site,
        TypeCode: this.formValues.TypeCode,
        Buyer: this.formValues.Buyer,
        UploadTimeFrom: startDate,
        UploadTimeTo: endDate,
      }

    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      this.listofreportdata = res.data
      this.total = res.total;
      this.tanslateService.get('QuerySuccess').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      this.loading = false;
    });
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  //提交表单
  handleOk(): void {
    this.isVisible = false;
    if (this.id != null) {
      this.update()
    }
    else {
      this.updatecontract()
    }

  }

  //新增时打开modal
  showModal() {
    let language = sessionStorage.getItem("wmsmlang");
    if (language == 'zh-TW') {
      this.nzTitle = "新增合同模板"
    }
    if (language == 'zh-CN') {
      this.nzTitle = "新增合同模板"
    }
    if (language == 'en') {
      this.nzTitle = "Add contract template"
    }
    this.UploadProofFile = null;
    this.id = null
    this.validateForm.reset();
    this.validateForm.controls['FORMNumber'].enable();
    this.validateForm.controls['CNContractName'].enable();
    this.validateForm.controls['ENContractName'].enable();
    this.validateForm.controls['ModalVersions'].enable();
    this.validateForm.controls['ModalSite'].enable();
    this.validateForm.controls['TypeCode'].enable();
    this.validateForm.controls['ModalType'].setValue('Y');
    this.uploadedFileName = null
    this.fileToken = null;
    this.GetSite()
    this.isVisible = true;
  }


  //编辑时打开modal
  EditShowModal(data) {

    let language = sessionStorage.getItem("wmsmlang");
    if (language == 'zh-TW') {
      this.nzTitle = "編輯合同模板"
    }
    if (language == 'zh-CN') {
      this.nzTitle = "编辑合同模板"
    }
    if (language == 'en') {
      this.nzTitle = "Edit contract template"
    }
    this.UploadProofFile = null;
    this.isVisible = true;
    this.id = data.id

    this.validateForm.controls['CNContractName'].setValue(data['chContractName']);
    this.validateForm.controls['ENContractName'].setValue(data['enContractName']);
    this.validateForm.controls['TypeCode'].setValue(data['typeCode']);
    this.validateForm.controls['ModalVersions'].setValue(data['versions']);
    if (data['site'] == "ALL") {
      this.validateForm.controls['ModalSite'].setValue("ALL")
    } else {
      this.validateForm.controls['ModalSite'].setValue(this.SiteList.find(o => o.siteName == data['site']).siteCode);
    }

    this.validateForm.controls['ModalType'].setValue(data['status']);
    this.validateForm.controls['Background'].setValue(data['backGround']);
    this.validateForm.controls['Purpose'].setValue(data['goal']);
    this.validateForm.controls['FORMNumber'].setValue(data['formNumber']);
    this.validateForm.controls['Limit'].setValue(data['approvalTimeLimit']);
    this.validateForm.controls['CNContractName'].disable();
    this.validateForm.controls['ENContractName'].disable();
    this.validateForm.controls['ModalVersions'].disable();
    this.validateForm.controls['ModalSite'].disable();
    this.validateForm.controls['FORMNumber'].disable();
    this.validateForm.controls['TypeCode'].disable();
    this.uploadedFileName = data.fileName
    this.fileToken = data.fileToken;

  }


  //复制时打开modal
  CopyShowModal(data) {
    let language = sessionStorage.getItem("wmsmlang");
    if (language == 'zh-TW') {
      this.nzTitle = "複製合同模板"
    }
    if (language == 'zh-CN') {
      this.nzTitle = "复制合同模板"
    }
    if (language == 'en') {
      this.nzTitle = "Copy contract template"
    }
    this.UploadProofFile = null;

    this.isVisible = true;
    this.id = null
    this.GetSite()
    this.validateForm.controls['TypeCode'].setValue(data['typeCode']);
    this.validateForm.controls['CNContractName'].setValue(data['chContractName']);
    this.validateForm.controls['ENContractName'].setValue(data['enContractName']);
    this.validateForm.controls['ModalVersions'].setValue(data['versions']);
    this.validateForm.controls['ModalSite'].setValue(data['siteCode']);
    this.validateForm.controls['ModalType'].setValue(data['status']);
    this.validateForm.controls['Background'].setValue(data['backGround']);
    this.validateForm.controls['Purpose'].setValue(data['goal']);
    this.validateForm.controls['Limit'].setValue(data['approvalTimeLimit']);
    this.validateForm.controls['FORMNumber'].setValue(data['formNumber']);
    this.validateForm.controls['CNContractName'].disable();
    this.validateForm.controls['ENContractName'].disable();
    this.validateForm.controls['ModalVersions'].enable();
    this.validateForm.controls['ModalSite'].enable();
    this.validateForm.controls['FORMNumber'].enable();
    this.validateForm.controls['TypeCode'].disable();
    this.uploadedFileName = null
    this.fileToken = null;
  }



  downloadFile() {
    if (!this.fileToken) { return }
    this.webApiService.downloadFileByToken(this.fileToken).subscribe(
      (res) => {
        this.downloadFile8(res, this.uploadedFileName);
        this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  removeFile() {
    this.uploadedFileName = null;
    this.fileToken = null;
    this.UploadProofFile = null;
    this.tanslateService.get('FileRemoved').subscribe((translatedText: string) => {
      this.NzMessageService.success(translatedText);
    })
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.UploadProofFile = file;
    if (file.name != null || file.name != undefined) {

      this.uploadedFileName = file.name
    }
    this.NzMessageService.success(this.tanslateService.instant('UploadSuccess'));
    this.handleChange
    return false;
  };

  //新增时提交
  updatecontract() {
    if (this.UploadProofFile == null || this.UploadProofFile == undefined) {

      this.tanslateService.get('PleaseUploadTheContractFile').subscribe((translatedText: string) => {
        this.NzMessageService.error(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   this.NzMessageService.error('請上傳合同文件');
      // }
      // if (language == 'zh-CN') {
      //   this.NzMessageService.error('请上传合同文件');
      // }
      // if (language == 'en') {
      //   this.NzMessageService.error('Please upload the contract file');
      // }
      this.isVisible = true
    } else {
      this.saveExcelData(this.UploadProofFile)
    }

  }


  //更新时提交
  update() {
    this.updatelData(this.UploadProofFile)
  }


  updatelData(file) {
    this.loading = true;
    if (this.validateForm.controls['CNContractName'].value == null || this.validateForm.controls['CNContractName'].value == "" || this.validateForm.controls['ENContractName'].value == null || this.validateForm.controls['ENContractName'].value == ""
      || this.validateForm.controls['ModalVersions'].value == null || this.validateForm.controls['ModalVersions'].value == "" || this.validateForm.controls['ModalSite'].value == ""
      || this.validateForm.controls['ModalSite'].value == null || this.validateForm.controls['ModalType'].value == null || this.validateForm.controls['ModalType'].value == ""
      || this.validateForm.controls['FORMNumber'].value == null || this.validateForm.controls['FORMNumber'].value == ""
      || this.validateForm.controls['Limit'].value == null || this.validateForm.controls['Limit'].value == "") {

      this.tanslateService.get('CheckRequired').subscribe((translatedText: string) => {
        this.NzMessageService.error(translatedText);
      })

      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   this.NzMessageService.error('請檢查必填項');
      // }
      // if (language == 'zh-CN') {
      //   this.NzMessageService.error('请检查必填项');
      // }
      // if (language == 'en') {
      //   this.NzMessageService.error('Please check the required fields');
      // }
      this.isVisible = true
      return this.loading = false;
    } else {
      const formData = new FormData();
      formData.append('Files', file);
      formData.append('contract', "contract");
      formData.append('Status', this.validateForm.controls['ModalType'].value);
      formData.append('BackGround', this.validateForm.controls['Background'].value);
      formData.append('Goal', this.validateForm.controls['Purpose'].value);
      formData.append('Versions', this.validateForm.controls['ModalVersions'].value);
      formData.append('Site', this.validateForm.controls['ModalSite'].value);
      formData.append('FormNumber', this.validateForm.controls['FORMNumber'].value);
      formData.append('ApprovalTimeLimit', this.validateForm.controls['Limit'].value);
      formData.append('TypeCode', this.validateForm.controls['TypeCode'].value);
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateContract.url}?id=` + this.id;
      const _headers = new HttpHeaders().set(
        'Authorization',
        'Bearer ' + this.AuthService.getToken()
      ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
      const req = new HttpRequest('POST', url, formData, {
        headers: _headers,
      });
      this.http
        .request(req)
        .pipe(filter((e) => e instanceof HttpResponse))
        .subscribe(
          (res) => {
            this.getReport()
            this.tanslateService.get('SuccessfulModification').subscribe((translatedText: string) => {
              this.NzMessageService.success(translatedText);
            })
            //this.NzMessageService.success('成功修改');
            this.loading = false;
          },
          (error) => {
            this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            //this.NzMessageService.error('upload failed.');
            this.loading = false;
          }
        );
    }

  }


  //新增合同
  saveExcelData(file) {

    this.loading = true;
    if (this.validateForm.controls['CNContractName'].value == null || this.validateForm.controls['CNContractName'].value == "" || this.validateForm.controls['ENContractName'].value == null || this.validateForm.controls['ENContractName'].value == ""
      || this.validateForm.controls['ModalVersions'].value == null || this.validateForm.controls['ModalVersions'].value == "" || this.validateForm.controls['ModalSite'].value == ""
      || this.validateForm.controls['ModalSite'].value == null || this.validateForm.controls['ModalType'].value == null || this.validateForm.controls['ModalType'].value == ""
      || this.validateForm.controls['FORMNumber'].value == null || this.validateForm.controls['FORMNumber'].value == ""
      || this.validateForm.controls['Limit'].value == null || this.validateForm.controls['Limit'].value == "") {

      this.tanslateService.get('CheckRequired').subscribe((translatedText: string) => {
        this.NzMessageService.error(translatedText);
      })

      this.isVisible = true
      return this.loading = false;
    } else {
      const formData = new FormData();

      formData.append('Files', file);
      formData.append('ChContractName', this.validateForm.controls['CNContractName'].value);
      formData.append('EnContractName', this.validateForm.controls['ENContractName'].value);
      formData.append('Versions', this.validateForm.controls['ModalVersions'].value);
      formData.append('Site', this.validateForm.controls['ModalSite'].value);
      formData.append('Status', this.validateForm.controls['ModalType'].value);
      formData.append('BackGround', this.validateForm.controls['Background'].value);
      formData.append('Goal', this.validateForm.controls['Purpose'].value);
      formData.append('FormNumber', this.validateForm.controls['FORMNumber'].value);
      formData.append('ApprovalTimeLimit', this.validateForm.controls['Limit'].value);
      formData.append('TypeCode', this.validateForm.controls['TypeCode'].value);
      formData.append('contract', "contract");
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadContract.url}`;
      const _headers = new HttpHeaders().set(
        'Authorization',
        'Bearer ' + this.AuthService.getToken()
      ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
      const req = new HttpRequest('POST', url, formData, {
        headers: _headers,
      });
      this.http
        .request(req)
        .pipe(filter((e) => e instanceof HttpResponse))
        .subscribe(
          (res) => {
            if (res['body']['status'] == 0o0) {
              this.tanslateService.get('contracterror').subscribe((translatedText: string) => {
                this.NzMessageService.error(translatedText);
              })
              // this.NzMessageService.error('请勿上传相同名称，版本，厂区的合同模板');
              this.loading = false;
            } else {
              this.getReport()
              this.tanslateService.get('SuccessfulAdd').subscribe((translatedText: string) => {
                this.NzMessageService.success(translatedText);
              })
              //this.NzMessageService.success('成功新增');
              this.loading = false;
            }

          },
          (error) => {
            this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            //this.NzMessageService.error('upload failed.');
            this.loading = false;
          }
        );
    }

  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'done') {
      this.uploadedFileName = info.file.response.name;
    }
  }


  GetSite() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.SiteList = res

      },
      (error) => {
      }
    );
  }

  onRadioClick(value: string): void {
    if (this.cancelSelection) {
      this.selectedValue = null;
      this.cancelSelection = false;
    } else {
      this.selectedValue = value;
    }
  }

  onCancelSelectionClick() {
    this.cancelSelection = true;
  }


  download(data) {
    this.webApiService.downloadFileByToken(data.fileToken).subscribe(
      (res) => {
        this.downloadFile8(res, data.fileName);
        this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // this.NzMessageService.success("下载成功");
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  cancel(): void {
  }

  confirm(data): void {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteContract.url}?id=` + data.id;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.tanslateService.get('successfullyDelete').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        //this.NzMessageService.info('删除成功');
        this.getReport()
      },
      (error) => {
      }
    );

  }

  sendQuery() {
    let value = this.isShowCondition;
    this.outQuery.emit(value);
  }


  sortChange(e) {
    this.listofreportdata = e === 'ascend' ? this.listofreportdata.sort(
      (a, b) => a.chContractName.localeCompare(b.chContractName)
    ) : this.listofreportdata.sort(
      (a, b) => b.chContractName.localeCompare(a.chContractName)
    )
  }

  sortChangeEN(e) {
    this.listofreportdata = e === 'ascend' ? this.listofreportdata.sort(
      (a, b) => a.enContractName.localeCompare(b.enContractName)
    ) : this.listofreportdata.sort(
      (a, b) => b.enContractName.localeCompare(a.enContractName)
    )
  }

  sortChangeversion(e) {
    this.listofreportdata = e === 'ascend' ? this.listofreportdata.sort(
      (a, b) => a.versions.localeCompare(b.versions)
    ) : this.listofreportdata.sort(
      (a, b) => b.versions.localeCompare(a.versions)
    )
  }

  sortChangeMDate(e) {

    if (e === 'ascend') {
      this.listofreportdata.sort((a, b) => a.mDate - b.mDate);
    } else {
      this.listofreportdata.sort((a, b) => b.mDate - a.mDate);
    }
  }


  //下载
  downloadTable() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadContractTemplateExcel.url}`;

    const startDate = this.getStartOfDayString(this.formValues?.UploadTime?.[0]) || '';
    const endDate = this.getStartOfDayString(this.formValues?.UploadTime?.[1]) || '';
    const params = {
      data: {
        Site: this.formValues.Site,
        ChContractName: this.formValues.ContractName,
        EnContractName: this.formValues.ContractNameEn,
        Versions: this.formValues.Versions,
        Status: this.formValues.Status,
        UploadTimeFrom: startDate,
        UploadTimeTo: endDate
      }
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      //this.NzMessageService.success('下载成功');
      this.downloadFile8(res, `Contract_Template_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
    this.loading = false;
  }

  //合同类型
  GetContractTypeCode() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetContractTypeCode.url}`;
    const params = {
    };
    this.webApiService.doGet(url, params).subscribe((res) => {
      this.TypeList = res.data
    });
    this.loading = false;
  }

  onQueryClick() {
    return 'ContractTemplate';
  }

  // 将选中的日期转换为当天 00:00:00 的 ISO 字符串（常见后端可识别：YYYY-MM-DDTHH:mm:ss）
  private getStartOfDayString(input: any): string {
    if (!input) { return ''; }
    try {
      const d = new Date(input);
      if (isNaN(d.getTime())) { return ''; }
      d.setHours(0, 0, 0, 0);
      // 统一输出为 ISO 本地样式：YYYY-MM-DDTHH:mm:ss（不带时区）
      const pad = (n: number) => n.toString().padStart(2, '0');
      const yyyy = d.getFullYear();
      const mm = pad(d.getMonth() + 1);
      const dd = pad(d.getDate());
      const hh = '00';
      const mi = '00';
      const ss = '00';
      return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
    } catch {
      return '';
    }
  }

}


